import React from 'react';
import { Backdrop } from '@mui/material';
import { selectLoaderState } from '../../features/ui/loaderSlice';
import { useAppSelector } from '../../state/hooks';
import animatedLoader from '../../assets/images/UI-dashboard/loader-animation.gif';

const GlobalLoader: React.FC = () => {
  const isLoading = useAppSelector(selectLoaderState);
  return (
    <Backdrop
      sx={{
        color: '#DF2020',
        zIndex: 1000,
      }}
      open={isLoading}
    >
      <img width={150} height={150} src={animatedLoader} alt="animated_loader" />
    </Backdrop>
  );
};

export default GlobalLoader;
